/**
 * Creator attribution: ?ref=<handle> -> cart attribute -> order.
 *
 * WHY NOT A DISCOUNT CODE. Tested against the live tier on 2026-09-02: Shopify
 * does not combine a non-combinable code with an automatic discount, it keeps
 * whichever is worth MORE to the customer and silently drops the other. A
 * creator code worth less than "Buy 3, save 40%" is dropped without an error,
 * so attribution would have succeeded on 1-item carts (47% of orders) and
 * vanished on 2+ carts (53%) - which are exactly the carts creator content
 * drives. A cart attribute never touches the discount stack, so it cannot be
 * outbid.
 *
 * WINDOW AND POLICY. 30-day last click, matching the ShopMy tracker already on
 * the page so the two cannot disagree about who earned a sale.
 *
 * The attribute rides cart -> checkout -> order.customAttributes, which is what
 * the payout ledger reads. Nothing here is load-bearing for the storefront: if
 * every request in this file fails, the shopper still checks out normally.
 */
(function creatorRef() {
  if (window.__icCreatorRef) return;
  window.__icCreatorRef = true;

  var KEY = 'ic_creator_ref';
  var ATTR = 'creator';
  var ATTR_TS = 'creator_ts';
  var WINDOW_DAYS = 30;
  var PARAMS = ['ref', 'creator'];

  var script = document.currentScript;
  var endpoint =
    (script && script.getAttribute('data-endpoint')) ||
    window.IC_CREATOR_ENDPOINT ||
    '';

  /** Handles are used in URLs, payouts and SQL. Keep them boring. */
  function clean(v) {
    if (!v) return null;
    v = String(v).trim().toLowerCase();
    return /^[a-z0-9][a-z0-9_-]{0,39}$/.test(v) ? v : null;
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.ref) return null;
      if (Date.now() - o.ts > WINDOW_DAYS * 864e5) {
        localStorage.removeItem(KEY);
        return null;
      }
      return o;
    } catch (e) {
      return null;
    }
  }

  function write(ref) {
    var o = { ref: ref, ts: Date.now() };
    try {
      localStorage.setItem(KEY, JSON.stringify(o));
    } catch (e) {
      /* private mode - the cart attribute below still carries this session */
    }
    return o;
  }

  /** Fire-and-forget click beacon. Deduped to one per ref per tab session. */
  function ping(ref) {
    if (!endpoint) return;
    var seen = 'ic_ref_pinged_' + ref;
    try {
      if (sessionStorage.getItem(seen)) return;
      sessionStorage.setItem(seen, '1');
    } catch (e) {
      /* if sessionStorage is unavailable we may double-count; better than none */
    }
    var body = JSON.stringify({
      ref: ref,
      path: location.pathname + location.search,
      referrer: document.referrer || null,
      ts: new Date().toISOString()
    });
    try {
      // keepalive so the beacon survives the shopper navigating immediately.
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  /**
   * Put the ref on the cart. /cart/update.js merges attributes rather than
   * replacing them, so this cannot disturb _free_gift or anything else.
   */
  function syncCart(o) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = (cart && cart.attributes && cart.attributes[ATTR]) || null;
        if (current === o.ref) return;
        var attrs = {};
        attrs[ATTR] = o.ref;
        attrs[ATTR_TS] = new Date(o.ts).toISOString();
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () {});
  }

  function start() {
    var incoming = null;
    try {
      var qs = new URLSearchParams(location.search);
      for (var i = 0; i < PARAMS.length && !incoming; i++) {
        incoming = clean(qs.get(PARAMS[i]));
      }
    } catch (e) {}

    var stored = read();

    // Last click wins inside the window, which is the affiliate norm and what
    // the ShopMy tracker on this page already does.
    if (incoming && (!stored || stored.ref !== incoming)) {
      stored = write(incoming);
    } else if (incoming && stored) {
      stored = write(incoming); // same creator, refresh the clock
    }

    if (incoming) ping(incoming);
    if (stored) syncCart(stored);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
